const jwt = require('jsonwebtoken');

export default class AuthService {
  constructor(apiService, authStorageService) {
    this.apiService = apiService;
    this.authStorageService = authStorageService;
    this.initialize();
  }

  initialize() {
    const auth = this.authStorageService.getAuth();
    if (!this.authStorageService.isAuthValid(auth)) {
      this.authStorageService.setAuth(null);
    }
  }

  async signIn({ email, password }) {
    const response = await this.apiService.post('/api/v1/auth', { email: email, password: password });
    const decodedAuth = jwt.decode(response.access_token);
    const localLanguage = localStorage.getItem('lng');

    this.authStorageService.setAuth({
      ...response,
      role: decodedAuth.role,
      email: decodedAuth.email,
      username: decodedAuth.username,
      language: decodedAuth.language || (localLanguage ? JSON.parse(localLanguage).toUpperCase() : 'EN'),
    });
    return response;
  }

  async restorePasswordEmail(data) {
    const response = await this.apiService.post('/api/v1/auth/password', data);
    return response;
  }
  async restorePassword(data) {
    const response = await this.apiService.put('/api/v1/auth/password', data);
    return response;
  }

  async signOut() {
    this.authStorageService.removeAuth();
  }
}
